<template>
  <div>
    <vs-row class="mt-1 al-center">
      <h4 class="ml-2">{{ text }}</h4>
      <vs-spacer />
      <vs-select
        class="selectExample"
        width="120px"
        v-model="select1"
        @change="linechart"
      >
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item, index) in options_graph"
        />
      </vs-select> </vs-row
    >
    <!-- <br /> -->
    <div style="position: relative; width: 100%">
      <LineChart
      v-if="option_power != null"
        :height="heightgrapg"
        :chartData="datacollection_power"
        :optionsChart="option_power"
      ></LineChart>
    </div>
    <vs-row class="aText" style="align-items: center">
      <div
        :style="{
          width: '10%',
          'margin-left': '2%',
          'border-radius': '20px',
          'background-color': colorgraph,
          color: colorgraph,
          height: '2%',
        }"
      >
        .
      </div>
      <a class="ml-1">{{text.split(" ")[0]}}</a>
      <vs-spacer />
      <div class="mr-3">
        <p style="color: #fc8200" class="mb-1">avg</p>
        <p>{{ avg.toFixed(3) }}</p>
      </div>
      <div class="mr-3">
        <p style="color: #ff006a" class="mb-1">min</p>
        <p>{{ min.toFixed(3) }}</p>
      </div>
      <div class="mr-3">
        <p style="color: #d400ff" class="mb-1">max</p>
        <p>{{ max.toFixed(3) }}</p>
      </div>
    </vs-row>
  </div>
</template>

<script>
// import lineChart from "./Chart";
import LineChart from "@/components/ChartJs/LineChart.js";

export default {
  components: { LineChart },
  props: ["text", "colorgraph", "heightgrapg", "datasets3",'legend'],
  data() {
    return {
      select1: 4,
      options_graph: [
        { text: "3 hr", value: 4 },
        { text: "6 hr", value: 2 },
        { text: "12 hr", value: 1 },
      ],
      datacollection_power: null,
      option_power: null,
      max: 0,
      min: 0,
      avg: 0,
    };
  },
  methods: {
    linechart() {
      let index =this.datasets3.labels.length- Math.round(this.datasets3.labels.length / this.select1);
      let total = 0;
      this.max = Number(this.datasets3.data[this.datasets3.data.length-1])
      this.min = Number(this.datasets3.data[this.datasets3.data.length-1])


      // console.log(this.datasets3.data);
      let newdata = this.datasets3.data.slice(index);
      let newlabels = this.datasets3.labels.slice(index);
      let NumData = [];
      let foematLabels = [];
      // console.log(newdata);
      for (let i = 0; i < newdata.length; i++) {
        const el = newdata[i];
        // console.log(Number(el));
        NumData.push(Number(el));
        // foematLabels.push(this.$moment(newlabels[i]).format("HH:mm"))
        foematLabels.push(newlabels[i])

        this.max = Number(el) > this.max ? Number(el) : this.max;
        this.min = Number(el) < this.min ? Number(el) : this.min;
        total += Number(el);

      }
      this.avg = total / newdata.length;
      this.$emit("max-min",[this.max,this.min]);
      // console.log("min",this.min);
      this.datacollection_power = {
        labels: foematLabels,
        datasets: [
          {
            data: NumData,
            borderWidth: 1.5,
            fill: false,
            borderColor: this.colorgraph,
          },
        ],
      };
      this.option_power = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                steps: 5,
                stepValue: 5,
              },
              position: "left",
              scaleLabel: {
                display: false,
                labelString: "m3",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };
    },
  },
  mounted() {
    this.linechart();
  },
};
</script>

<style scoped>
/* .aText {
  font-size: 0.1rem;
} */
.al-center {
  align-items: center;
}
</style>